import React, { useId } from 'react';
import { useTheme } from '../../theme/ThemeProvider';
import { ThemePreference } from '../../theme/theme';
import './AppearanceSettings.css';

const OPTIONS: { value: ThemePreference; label: string }[] = [
  { value: 'light', label: 'Light' },
  { value: 'dark', label: 'Dark' },
  { value: 'system', label: 'Match system' },
];

interface Props {
  /** Show the "Appearance" h4. Turn off when the surrounding page already has that heading. */
  showHeading?: boolean;
}

const AppearanceSettings: React.FC<Props> = ({ showHeading = true }) => {
  const { preference, resolved, setPreference } = useTheme();
  const id = useId();
  const headingId = `${id}-heading`;
  return (
    <div className={`appearance-settings${showHeading ? '' : ' appearance-settings--bare'}`}>
      {showHeading && <h4 id={headingId}>Appearance</h4>}
      <div
        className="appearance-settings__options"
        role="radiogroup"
        {...(showHeading ? { 'aria-labelledby': headingId } : { 'aria-label': 'Appearance' })}
      >
        {OPTIONS.map((option) => (
          <label
            key={option.value}
            className={`appearance-settings__option${preference === option.value ? ' appearance-settings__option--active' : ''}`}
          >
            <input
              type="radio"
              name={`${id}-appearance`}
              value={option.value}
              checked={preference === option.value}
              onChange={() => setPreference(option.value)}
            />
            {option.label}
          </label>
        ))}
      </div>
      {preference === 'system' && (
        <p className="appearance-settings__help">{`(currently ${resolved === 'dark' ? 'Dark' : 'Light'})`}</p>
      )}
    </div>
  );
};

export default AppearanceSettings;
